import React from 'react';
import ImageModal from './ImageModal';

interface Props {
    url: string;
}

interface State {
    modalVisible: boolean;
}

class ImagePreview extends React.Component<Props, State> {
    public state = {
        modalVisible: false,
    };

    public render() {
        if (!this.props.url) {
            return '';
        }

        return (
            <>
                <a onClick={() => { this.setState({ modalVisible: true }); }}><img src={this.props.url} style={{ width: '100%' }} /></a>

                {this.state.modalVisible && <ImageModal
                    url={this.props.url}
                    visible={this.state.modalVisible}
                    onClose={() => {
                        this.setState({ modalVisible: false });
                    }}
                />}
            </>
        );
    }
}

export default ImagePreview;



// WEBPACK FOOTER //
// ./src/components/ImagePreview.tsx